<template>
  <div class="VirginiaNotice">
    <h2 class="VirginiaNotice_Heading">
      PRIVACY NOTICE FOR VIRGINIA RESIDENTS
    </h2>

    <p>
      If you are a Virginia resident, you have the right to request, subject to
      our verification:
    </p>

    <ul class="VirginiaNotice_BulletPoints">
      <li>
        To confirm whether or not a controller is processing your Personal
        Information and to access such Personal Information;
      </li>
      <li>To correct inaccuracies in your Personal Information;</li>
      <li>To delete your Personal Information;</li>
      <li>
        To obtain a copy of your Personal Information that you previously
        provided to us in a portable, and if technically feasible, readily
        usable format, if processing is carried out by automated means;
      </li>
      <li>
        To opt out of the processing of your Personal Information for purposes
        of (i) targeted advertising, (ii) the sale of Personal Information, or
        (iii) profiling in furtherance of decisions that produce legal or
        similarly significant effects concerning the consumer.
      </li>
    </ul>

    <p>
      <span class="VirginiaNotice_ItemTitle">Right to Non-Discrimination:</span>
      Grove Collaborative will not discriminate against consumers who exercise
      their rights. Specifically, if you exercise your rights, we will not deny
      you access to the site or Services, charge you different prices or rates
      for products or Services or provide you a different level or quality of
      products or Services. However, as permitted by VCDPA, we may offer you
      certain financial incentives that can result in different prices, rates,
      or quality levels. Any permitted financial incentive we offer will
      reasonably relate to the value of your Personal Information, for instance,
      if you sign up for a newsletter with us, we may provide you with discounts
      for future services. Participation in a financial incentive program
      requires your prior opt in consent, which you may revoke at any time.
    </p>

    <p>
      <span class="VirginiaNotice_ItemTitle"
        >Sensitive Information Opt-In:</span
      >
      We must also obtain your express consent prior to collecting and
      processing certain categories of Sensitive Personal Information such as
      precise geolocation data, data about protected characteristics and genetic
      biometric data. We do not generally collect this type of information from
      consumers, except when you choose to provide specific health diagnosis
      (such as pregnancy) in your responses to the Grove Wellness quiz.
      submitting your information to the Grove Wellness quiz-you agree that we
      may use this information to display, email and offer Grove product
      information.
    </p>

    <p>
      If you are a resident of Virginia and wish to exercise any of your rights
      under the VCDPA, you or your authorized agent may make a request to
      confirm, access, correct, delete, obtain a copy, or opt-out of the
      processing of your Personal Information for targeting advertising, sale,
      or profiling by submitting a Privacy Request Form
      <SkyLink
        inline
        to="https://preferences.grove.co/privacy"
        target="_blank"
        tag="a"
        >here</SkyLink
      >, or by emailing
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co.</SkyLink
      >
    </p>

    <p>
      If you use an authorized agent to submit your request, we may require
      proof of the written authorization you have given. We also may require you
      to confirm your identity and your residency in order to obtain the
      information, and you are only entitled to make this request up to twice
      annually. For emails, please include “Virginia Privacy Rights” as the
      subject line. You must include your full name, email address, and attest
      to the fact that you are a Virginia resident. We will process your request
      within 45 days or let you know if we need additional time or cannot
      process your request. If you make this request by telephone, we may also
      ask you to provide the request in writing so that we may verify your
      identity. If we are unable to honor your request for any reason, we will
      notify you of the reason within the request time period.
    </p>

    <p>
      If we decline to take action on your request, you can appeal our decision
      by submitting an email to
      <SkyLink inline to="mailto:support@grove.co" tag="a"
        >support@grove.co</SkyLink
      >
      entitled
      <span class="VirginiaNotice_ItemTitle"
        >“Virginia Privacy Rights Appeal”</span
      >
      and we will review your request and respond within 60 days of the receipt
      of your appeal with a written explanation of the reasons for our decision.
      If your appeal is denied, you may contact the Virginia Attorney General to
      submit a complaint.
    </p>
  </div>
</template>

<style lang="scss">
.VirginiaNotice {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
    text-align: center;
  }

  &_ItemTitle {
    text-decoration: underline;
  }

  &_BulletPoints {
    margin: 0;
    display: grid;
    row-gap: var(--spacing-2x);
  }
}
</style>
